import { SvgIcon } from "@material-ui/core";
import React from "react";

export const ChefHatIcon: React.FC = (props) => {
	return (
		<SvgIcon {...props}>
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256">
				<rect width="256" height="256" fill="none" />
				<line
					x1="96"
					y1="160"
					x2="88"
					y2="128"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<line
					x1="160"
					y1="160"
					x2="168"
					y2="128"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<line
					x1="128"
					y1="160"
					x2="128"
					y2="128"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<path
					d="M173.65,65.12A48,48,0,1,1,184,160H72A48,48,0,1,1,82.35,65.12"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<path
					d="M80,80a48,48,0,0,1,96,0"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
				<path
					d="M200,157.27V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V157.27"
					fill="none"
					stroke="currentColor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="16"
				/>
			</svg>
		</SvgIcon>
	);
};
